module.exports = __webpack_public_path__ + "img/btn_tab_4@3x.0ea1c730.png";